import Vue from 'vue'
import Router from 'vue-router'

const baseRoutes = [
	{
		path: '/',
		name: 'Home',
		component: () => import('@/views/home/Home'),
	},
	{
		path: '/lista-productos/:path?',
		name: 'Products',
		component: () => import('@/views/pages/Products'),
	},
	{
		path: '/lista-productos/:path/:slug-detail',
		name: 'ProductDetail',
		component: () => import('@/views/pages/ProductDetail'),
	},
	{
		path: '/tienda/producto/:slug',
		name: 'ProductDetail',
		component: () => import('@/views/pages/TiendaDetail'),
	},
	{
		path: '/tienda/:category?/:subcategory?',
		name: 'Tienda',
		component: () => import('@/views/pages/Tienda'),
	},
	

	{
		path: '/contacto',
		name: 'Contact',
		component: () => import('@/views/pages/Contact'),
	},
	
	{
		path: '/checkout',
		name: 'Checkout',
		component: () => import('@/views/pages/Checkout'),
	},
	{
		path: '/order/:code',
		name: 'OrderDetail',
		component: () => import('@/views/pages/CheckoutDone'),
	},
	{
		path: '/order/:code/pay',
		name: 'OrderPayment',
		component: () => import('@/components/ecommerce/OrderPayment'),
	},
	{
		path: '/preguntas-frecuentes',
		name: 'Faqs',
		component: () => import('@/views/pages/Faqs'),
	},
	{
		path: '/:slug',
		name: 'Section',
		component: () => import('@/views/pages/Section'),
	},
	{
		path: '*',
		redirect: '/',
	},
]

const loadedRoutes = loadRoutes()
const routes = baseRoutes.concat(...loadedRoutes)

Vue.use(Router)

let router = new Router({
	mode: 'history',
	routes,
})

router.beforeEach((to, from, next) => {
	window.scrollTo(0, 0)
	next()
})
function loadRoutes() {
	const context = require.context('@/views/', true, /\.js$/)
	return context
		.keys()
		.map(context) // import module
		.map((m) => m.default) // get `default` export from each resolved module
}
export default router
